"use client";

import { createContext, useContext } from "react";

export const DashboardContext = createContext<{ deleteFromList: (id: string) => void, startAnalysis: (jobURL:string) => void }>({
  deleteFromList: () => {},
  startAnalysis: () => {}
});

export const useDashboard = () => useContext(DashboardContext);